/* global __DEVTOOLS__ */
import React, { Component } from 'react';
import {connect} from 'react-redux';
import Layout from "./Layout";
import {Route, Switch, Redirect} from "react-router-dom";
import LoginPage from "./LoginPage";
import PasswordResetRequestPage from "./PasswordResetRequestPage";
import PasswordResetPage from "./PasswordResetPage";
import CenovaNabidkaPage from "./CenovaNabidkaPage";
import ObjednavkaGuidPage from "./ObjednavkaGuidPage";
import { utils, authActions } from "@mc/mc-legacy";
const {storeFromArea} = utils;
import {Loader} from '@mc/mc-legacy';
import {withRouter} from "react-router";


class Routes extends Component {

    componentDidMount() {
        this.props.dispatch(authActions.fetchAuthInfoIfNeeded());
    }

    componentDidUpdate() {
        this.props.dispatch(authActions.fetchAuthInfoIfNeeded());
    }

    render() {
        const {authInfo} = this.props;

        if (!authInfo.fetched) {
            return <Loader />
        }

        const isGuest =  !authInfo.fetched || !authInfo.data.auth;

        if (isGuest) {
            // Pokud nepřihlášený uživatel přišel přes GUID objednávky (ve state je from), budeme dál propadávat
            // URL pro přesměrování po přihlášení.
            // V ostatních případech chceme po přihlášení vždy na hlavní stránku.
            let state;
            if (this.props.location.state && this.props.location.state.from) {
                state = {from: this.props.location}
            }
            return <Switch>
                <Route path={'/login'} component={LoginPage} />
                <Route path={'/password-reset-request'} component={PasswordResetRequestPage} />
                <Route path={'/password-reset'} component={PasswordResetPage} />
                <Route path={'/nabidka/:guid/:confirm'} component={CenovaNabidkaPage} />
                <Route path={'/nabidka/:guid'} component={ObjednavkaGuidPage} />
                <Route component={() => <Redirect to={{pathname: '/login', state}} />} />
            </Switch>
        }

        return (
            <Switch>
                <Route path={'/login'} component={LoginPage} />
                <Route path={'/nabidka/:guid/:confirm'} component={CenovaNabidkaPage} />
                <Route path={'/nabidka/:guid'} component={ObjednavkaGuidPage} />
                <Route component={Layout} />
            </Switch>
        )
    }
}


export default withRouter(connect((state, props) => ({authInfo: storeFromArea(state, authActions.AUTH_INFO_AREA)}))(Routes));
